import React from "react";
import PropTypes from "prop-types";
import cnames from "classnames";
import { Link } from "react-router-dom";

import TextLink from "@redbubble/design-system/react/TextLink";
import { CENTER } from "@redbubble/design-system/react/constants";

import styles from "./Tab.scss";

const Tab = ({ children, active, to, position, rel, forceReload }) => {
  const classNames = cnames(styles.container, {
    [styles.active]: active,
    [styles.nonPrimary]: position === CENTER,
  });

  // XXX(KS) 2026-07-08: We've swapped the artist shop over to be run from frontend, so we need these tabs
  // to force a reload so there is no client side routing to the old shop page. This is an opt-in prop so all
  // other uses of it are unaffected. This page is on the brink of decommissioning so is a hack for now.
  // I've checked the DS and passing this onclick, will pass it down through to the child.
  const forceReloadOnClick = () => {
    if (forceReload) window.location.href = to.pathname;
  };

  return (
    <TextLink onClick={forceReloadOnClick}>
      {(props) => (
        <Link {...props} to={to} className={classNames} rel={rel}>
          {children}
        </Link>
      )}
    </TextLink>
  );
};

Tab.propTypes = {
  children: PropTypes.node,
  active: PropTypes.bool,
  to: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  position: PropTypes.string,
  rel: PropTypes.string,
  forceReload: PropTypes.bool,
};

Tab.defaultProps = {
  children: undefined,
  to: {
    pathName: "",
  },
  active: false,
  position: undefined,
  rel: null,
  forceReload: false,
};

export default Tab;
